import { cloneDeep, forEach, omit, reduce, set } from 'lodash';
import { RESET_PAX, RESET_STORE, STORE } from '../global';
import { checkWhitelist } from '../reducer-utils';
import {
  RESET_PAYMENT_TOKEN_STATE,
  INITIATE_TOKEN,
  TRAVELLER_PAYMENT_DETAILS,
  TravellerPaymentStore,
  TOKENIZATION_STATE,
  PAYMENT_METHOD,
  RESET_PAYMENT_STORE,
  TravellerPaymentAction,
  SET_PAYMENT_TOKEN
} from './types';
import { getPaymentMethod, hasAllTokenCheck, setCcType } from './utils';

const initialState = {
  policyTokenizationInitiated: TOKENIZATION_STATE.NOT_STARTED
};

export const travellerPayment = (
  state: TravellerPaymentStore = {
    policyTokenizationInitiated: TOKENIZATION_STATE.NOT_STARTED
  },
  action: TravellerPaymentAction
): TravellerPaymentStore => {
  switch (action.type) {
    case RESET_PAYMENT_TOKEN_STATE : {
      return {
        ...state,
        policyTokenizationInitiated: TOKENIZATION_STATE.NOT_STARTED
    }
  }
    case INITIATE_TOKEN: {
      const act = action.cardHolderName;
      const { policyTokenizationInitiated, cardHolderName, ...rest } = state;
      const hasAllToken = hasAllTokenCheck({ paxId: 0 }, rest);
      const tokenState = hasAllToken ? TOKENIZATION_STATE.COMPLETED : TOKENIZATION_STATE.INITIATED;

      return {
        policyTokenizationInitiated: tokenState,
        cardHolderName: act,
        ...reduce(
          rest,
          (res, val) =>
            val.paymentMethod === PAYMENT_METHOD.CREDIT_CARD
              ? { ...res, [val.paxId]: { ...val, initiateToken: true } }
              : { ...res, [val.paxId]: val },
          {}
        )
      };
    }
    case TRAVELLER_PAYMENT_DETAILS: {
      const act = action.payload;
      const { paxId } = act;
      const { policyTokenizationInitiated, cardHolderName, ...rest } = state;
      const hasAllToken = hasAllTokenCheck(act, rest);
      const tokenState =
        policyTokenizationInitiated === TOKENIZATION_STATE.INITIATED && hasAllToken
          ? TOKENIZATION_STATE.COMPLETED
          : policyTokenizationInitiated;
      return {
        ...state,
        policyTokenizationInitiated: tokenState,
        [paxId]: {
          ...act,
          initiateToken: false
        }
      };
    }
    case SET_PAYMENT_TOKEN: {
      const act = action.payload;
      const { policyTokenizationInitiated, ...rest } = state;
      const cardHolderName = {};

      const paymentList = cloneDeep(rest);
      forEach(paymentList, (val, key) => {
        set(rest, key, {
          ...paymentList[key],
          token: act[`tokenNumber${key}`],
          ccType: setCcType(act[`tokenNumber${key}`]),
          paymentMethod: getPaymentMethod(act[`paymentMethod${key}`])
        });
        cardHolderName[`cardHolderName${key}`] = act[`cardHolderName${key}`];
      });

      return {
        policyTokenizationInitiated,
        cardHolderName,
        ...rest
      };
    }
    case RESET_STORE:
    case RESET_PAYMENT_STORE:
      return checkWhitelist(
        action.payload?.whitelist,
        STORE.TRAVELLER_PAYMENTS,
        state,
        initialState
      ) as TravellerPaymentStore;
    case RESET_PAX:
      return {
        ...omit(state, [action.payload.paxId])
      };
    default:
      return state;
  }
};
